const API_PREFIX: string = process.env.REACT_APP_BACKEND_API_PREFIX? process.env.REACT_APP_BACKEND_API_PREFIX : "/api";
const GOOGLE_MAPS_API_KEY: string = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || process.env.REACT_APP_GOOGLE_MAP_API_KEY || "key-needed-here";
const DEBUG: boolean = process.env.REACT_APP_DEBUG ? process.env.REACT_APP_DEBUG === 'true' : false;
// Cloudflare Turnstile site key (public). When empty the CAPTCHA is disabled
// client-side: the backend must also have its secret unset, otherwise every
// email request is rejected.
const TURNSTILE_SITE_KEY: string = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";


export const DEFAULT_ITALY_COORDINATES = {
  latitude: 41.8719,
  longitude: 12.5674,
  radius: 600_000,
  country: 'Italy'
};

export {
    API_PREFIX,
    GOOGLE_MAPS_API_KEY,
    DEBUG,
    TURNSTILE_SITE_KEY
};